import React from 'react';
import { Play, Pause } from 'lucide-react';
import './Music.css';
import albumElephant from '../assets/images/album-elephant.svg';
import usePageTitle from '../hooks/usePageTitle';

interface Track {
  name: string;
  duration: string;
  isSingle?: boolean;
}

interface Album {
  title: string;
  year: string;
  tracks: Track[];
}

interface MusicProps {
  playingTrack: number | null;
  onPlayTrack: (trackId: number) => void;
  album: Album;
}

const Music: React.FC<MusicProps> = ({ playingTrack, onPlayTrack, album }) => {
  usePageTitle('Music - The Kults');

  return (
    <div className="music-page">
      {/* Hero Section */}
      <section className="music-hero">
        <div className="container">
          <h1>MUSIC</h1>
          <p>RAW. UNTAMED. UNCOMPROMISING.</p>
          <div className="hero-subtitle">
            <span>DEBUT ALBUM</span>
            <span>•</span>
            <span>12 TRACKS</span>
            <span>•</span>
            <span>{album.year}</span>
          </div>
        </div>
      </section>

      {/* Album Section */}
      <section className="albums-section">
        <div className="container">
          <h2>DISCOGRAPHY</h2>
          <div className="album-card expanded">
            <div className="album-cover">
              <img src={albumElephant} alt={album.title} />
            </div>
            <div className="album-info">
              <h3>{album.title}</h3>
              <p className="album-year">{album.year}</p>
              <p className="album-description">THE DEBUT. THE RAW. THE REVOLUTION STARTS HERE.</p>
              <div className="album-stats">
                <span>{album.tracks.length} TRACKS</span>
                <span>•</span>
                <span>{album.tracks.filter(t => t.isSingle).length} SINGLES</span>
              </div>
            </div>
            <div className="album-tracks">
              <h4>TRACK LISTING</h4>
              <div className="tracks-list">
                {album.tracks.map((track, index) => (
                  <div
                    key={index}
                    className={`track-item ${track.isSingle ? 'single' : ''}`}
                    onClick={() => onPlayTrack(index + 1)}
                  >
                    <div className="track-info">
                      <span className="track-number">{String(index + 1).padStart(2, '0')}</span>
                      <span className="track-name">{track.name}</span>
                      {track.isSingle && <span className="single-badge">SINGLE</span>}
                    </div>
                    <div className="track-duration">
                      <span>{track.duration}</span>
                      <button className="play-track-btn">
                        {playingTrack === index + 1 ? <Pause size={16} /> : <Play size={16} />}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Streaming Section */}
      <section className="streaming-section">
        <div className="container">
          <h2>LISTEN EVERYWHERE</h2>
          <div className="streaming-grid">
            <a href="#" className="streaming-card spotify">
              <span className="platform">SPOTIFY</span>
              <span className="action">STREAM NOW</span>
            </a>
            <a href="#" className="streaming-card apple">
              <span className="platform">APPLE MUSIC</span>
              <span className="action">STREAM NOW</span>
            </a>
            <a href="https://www.youtube.com/@thekultsofficial" className="streaming-card youtube" target="_blank" rel="noopener noreferrer">
              <span className="platform">YOUTUBE</span>
              <span className="action">WATCH NOW</span>
            </a>
            <a href="#" className="streaming-card bandcamp">
              <span className="platform">BANDCAMP</span>
              <span className="action">BUY NOW</span>
            </a>
            <a href="#" className="streaming-card soundcloud">
              <span className="platform">SOUNDCLOUD</span>
              <span className="action">STREAM NOW</span>
            </a>
            <a href="#" className="streaming-card amazon">
              <span className="platform">AMAZON MUSIC</span>
              <span className="action">STREAM NOW</span>
            </a>
            <a href="#" className="streaming-card itunes">
              <span className="platform">ITUNES STORE</span>
              <span className="action">BUY NOW</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Music; 